import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "placeholder", "id", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name,
          class: _normalizeClass(["form-label", { 'form-label-invalid': _ctx.errors }])
        }, _toDisplayString(_ctx.label), 11, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      ref: "input",
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors }]),
      id: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      disabled: _ctx.disabled
    }, null, 10, _hoisted_2), [
      [_vModelDynamic, _ctx.value]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "invalid-feedback d-block",
        key: error
      }, _toDisplayString(error), 1))
    }), 128))
  ]))
}